import { getBackendBaseUrl } from './apiUrls';
import { optionalAuthHeaders } from './billingApi';

const FORMS_API_URL = `${getBackendBaseUrl()}/forms`;

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.message || data.error || 'Request failed');
    error.status = res.status;
    error.data = data;
    throw error;
  }
  return data;
}

async function formAuthHeaders({ getAccessTokenSilently, getIdTokenClaims } = {}) {
  return optionalAuthHeaders({ getAccessTokenSilently, getIdTokenClaims });
}

export async function fetchFormCatalog({
  userEmail,
  parentType,
  parentId,
  getAccessTokenSilently,
  getIdTokenClaims,
} = {}) {
  const params = new URLSearchParams();
  if (userEmail) params.set('user_email', userEmail);
  if (parentType) params.set('parent_type', parentType);
  if (parentId) params.set('parent_id', parentId);
  const query = params.toString();
  const headers = await formAuthHeaders({ getAccessTokenSilently, getIdTokenClaims });
  const res = await fetch(`${FORMS_API_URL}/catalog${query ? `?${query}` : ''}`, { headers });
  return parseJson(res);
}

export async function fetchSessionParents(token) {
  const res = await fetch(`${FORMS_API_URL}/sessions/${encodeURIComponent(token)}/parents`);
  return parseJson(res);
}

export async function fetchSessionPrefill(token, { formType, contractId, listingId, buyerAgreementId } = {}) {
  const params = new URLSearchParams();
  if (formType) params.set('form_type', formType);
  if (contractId) params.set('contract_id', contractId);
  if (listingId) params.set('listing_id', listingId);
  if (buyerAgreementId) params.set('buyer_agreement_id', buyerAgreementId);
  const query = params.toString();
  const res = await fetch(
    `${FORMS_API_URL}/sessions/${encodeURIComponent(token)}/prefill${query ? `?${query}` : ''}`,
  );
  return parseJson(res);
}

export async function fetchChildFormParents(formType, userEmail, { getAccessTokenSilently, getIdTokenClaims } = {}) {
  const params = new URLSearchParams({ form_type: formType, user_email: userEmail });
  const headers = await formAuthHeaders({ getAccessTokenSilently, getIdTokenClaims });
  const res = await fetch(`${FORMS_API_URL}/parents?${params}`, { headers });
  return parseJson(res);
}

export async function fetchChildFormPrefill({
  formType, userEmail, contractId, listingId, buyerAgreementId, getAccessTokenSilently, getIdTokenClaims,
}) {
  const params = new URLSearchParams({ form_type: formType, user_email: userEmail });
  if (contractId) params.set('contract_id', contractId);
  if (listingId) params.set('listing_id', listingId);
  if (buyerAgreementId) params.set('buyer_agreement_id', buyerAgreementId);
  const headers = await formAuthHeaders({ getAccessTokenSilently, getIdTokenClaims });
  const res = await fetch(`${FORMS_API_URL}/prefill?${params}`, { headers });
  return parseJson(res);
}

export async function generateChildForm(body, { getAccessTokenSilently, getIdTokenClaims } = {}) {
  const email = body.user_email || '';
  const headers = {
    'Content-Type': 'application/json',
    ...(await formAuthHeaders({ getAccessTokenSilently, getIdTokenClaims })),
  };
  const res = await fetch(`${FORMS_API_URL}/generate?user_email=${encodeURIComponent(email)}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  return parseJson(res);
}
